import {css,createGlobalStyle} from "styled-components";


//  在public.scss 中  todo: 待迁移
export default createGlobalStyle`



`;
